'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocationInput = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactInlinesvg = require('react-inlinesvg');

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _downshift = require('downshift');

var _downshift2 = _interopRequireDefault(_downshift);

var _icons = require('constants/icons');

var _debounce = require('helpers/debounce');

var _calculateTextWidth = require('helpers/calculateTextWidth');

var _verify = require('helpers/verify');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CURRENT_LOCATION = 'CURRENT_LOCATION';
var DEBOUNCE_MS = 250;
var MAX_SUGGESTIONS = 5;

var messages = (0, _reactIntl.defineMessages)({
  currentLocation: {
    id: 'locationInput.currentLocation',
    defaultMessage: 'Current location'
  }
});

var LocationInput = exports.LocationInput = function (_PureComponent) {
  (0, _inherits3.default)(LocationInput, _PureComponent);

  function LocationInput(props) {
    var _this, _this3;

    (0, _classCallCheck3.default)(this, LocationInput);

    _this = (_this3 = (0, _possibleConstructorReturn3.default)(this, (LocationInput.__proto__ || (0, _getPrototypeOf2.default)(LocationInput)).call(this, props)), _this3);
    _this3.state = {
      inputElement: null,
      inputValue: '',
      isActive: false
    };
    _this3.getInputValue = _this3.getInputValue.bind(_this3);
    _this3.handleInputStateChange = _this3.handleInputStateChange.bind(_this3);
    _this3.handleInputValueChange = _this3.handleInputValueChange.bind(_this3);
    _this3.handlePageLoaded = function () {
      return _this.forceUpdate();
    };
    _this3.handleSelection = _this3.handleSelection.bind(_this3);
    _this3.queryPlacesDebounced = (0, _debounce.debounce)(_this3.props.queryPlaces, DEBOUNCE_MS);
    return _this3;
  }

  (0, _createClass3.default)(LocationInput, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          inputLocation = _props.inputLocation,
          onLoad = _props.onLoad;


      if (onLoad) {
        onLoad(inputLocation);
      }

      if (typeof window !== 'undefined') {
        // Needed to correctly re-calculate the input width after the page has fully loaded.
        window.addEventListener('load', this.handlePageLoaded);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props2 = this.props,
          inputLocation = _props2.inputLocation,
          onChange = _props2.onChange;


      if (inputLocation !== prevProps.inputLocation) {
        onChange(inputLocation);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (typeof window !== 'undefined') {
        window.removeEventListener('load', this.handlePageLoaded);
      }
    }
  }, {
    key: 'getInputWidth',
    value: function getInputWidth() {
      var style = this.props.style;
      var isActive = this.state.isActive;

      var inputValue = this.getInputValue();

      if (typeof window !== 'undefined' && this.state.inputElement && style === 'underlined' && !isActive && inputValue) {
        var inputFont = (0, _calculateTextWidth.getElementFont)(this.state.inputElement);
        return (0, _calculateTextWidth.calculateTextWidth)(inputValue, inputFont);
      }
      return null;
    }
  }, {
    key: 'getIcon',
    value: function getIcon(item) {
      return item.place_id === CURRENT_LOCATION ? _icons.DESIGN_SYSTEM.currentLocation : _icons.DESIGN_SYSTEM.pin;
    }
  }, {
    key: 'getInputValue',
    value: function getInputValue() {
      var _props3 = this.props,
          initialValue = _props3.initialValue,
          inputLocation = _props3.inputLocation;
      var _state = this.state,
          inputValue = _state.inputValue,
          isActive = _state.isActive;

      // eslint-disable-next-line no-nested-ternary

      return isActive ? inputValue : inputLocation ? inputLocation.name : initialValue;
    }
  }, {
    key: 'getSuggestions',
    value: function getSuggestions() {
      var _props4 = this.props,
          hasDetectedLocation = _props4.hasDetectedLocation,
          intl = _props4.intl,
          placeSuggestions = _props4.placeSuggestions;


      return (hasDetectedLocation ? [{
        description: intl.formatMessage(messages.currentLocation),
        place_id: CURRENT_LOCATION
      }].concat((0, _toConsumableArray3.default)(placeSuggestions)) : placeSuggestions).slice(0, MAX_SUGGESTIONS);
    }
  }, {
    key: 'handleInputStateChange',
    value: function handleInputStateChange(stateChanges) {
      if (stateChanges.isOpen === true) {
        this.setState({
          inputValue: '',
          isActive: true
        });
      }

      if (stateChanges.isOpen === false || stateChanges.type === _downshift2.default.stateChangeTypes.blurInput) {
        this.setState({ isActive: false });
      }
    }
  }, {
    key: 'handleInputValueChange',
    value: function handleInputValueChange(query) {
      this.setState({ inputValue: query });
      this.queryPlacesDebounced(query);
    }
  }, {
    key: 'handleSelection',
    value: function handleSelection(place) {
      var _props5 = this.props,
          loadPlace = _props5.loadPlace,
          loadDetectedLocation = _props5.loadDetectedLocation,
          setInputSelection = _props5.setInputSelection;


      this.state.inputElement.blur();

      setInputSelection(place);
      if (place.place_id === CURRENT_LOCATION) {
        loadDetectedLocation();
      } else {
        loadPlace(place.place_id);
      }
    }
  }, {
    key: 'itemToString',
    value: function itemToString(item) {
      return item ? item.description : '';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props6 = this.props,
          label = _props6.label,
          inputAttributes = _props6.inputAttributes,
          selectedItem = _props6.selectedItem,
          style = _props6.style;


      var suggestions = this.getSuggestions();
      var extraClass = style === 'underlined' ? 'location-input--underlined' : null;

      return _react2.default.createElement(
        _downshift2.default,
        {
          inputValue: this.getInputValue(),
          itemToString: this.itemToString,
          onSelect: this.handleSelection,
          onStateChange: this.handleInputStateChange,
          onInputValueChange: this.handleInputValueChange,
          selectedItem: selectedItem
        },
        function (_ref) {
          var getInputProps = _ref.getInputProps,
              getItemProps = _ref.getItemProps,
              getLabelProps = _ref.getLabelProps,
              getMenuProps = _ref.getMenuProps,
              highlightedIndex = _ref.highlightedIndex,
              isOpen = _ref.isOpen,
              openMenu = _ref.openMenu;
          return _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)('location-input', extraClass) },
            label && _react2.default.createElement(
              'label',
              getLabelProps(),
              label
            ),
            _react2.default.createElement(
              'div',
              { className: 'location-input__input-wrapper' },
              _react2.default.createElement('input', (0, _extends3.default)({}, getInputProps((0, _extends3.default)({}, inputAttributes, {
                onFocus: openMenu
              })), {
                autoComplete: 'off',
                style: { width: _this2.getInputWidth() },
                ref: function ref(_ref2) {
                  return _this2.setState({ inputElement: _ref2 });
                }
              })),
              isOpen && !(0, _verify.isEmpty)(suggestions) && _react2.default.createElement(
                'ul',
                getMenuProps(),
                suggestions.map(function (item, index) {
                  return _react2.default.createElement(
                    'li',
                    (0, _extends3.default)({}, getItemProps({
                      key: item.place_id,
                      index: index,
                      item: item
                    }), {
                      className: (0, _classnames2.default)('location-input__item', {
                        'location-input__item--highlighted': highlightedIndex === index
                      })
                    }),
                    _react2.default.createElement(_reactInlinesvg2.default, { className: 'location-input__icon', src: _this2.getIcon(item) }),
                    item.description
                  );
                })
              )
            )
          );
        }
      );
    }
  }]);
  return LocationInput;
}(_react.PureComponent);

LocationInput.propTypes = {
  hasDetectedLocation: _propTypes2.default.bool,
  initialValue: _propTypes2.default.string,
  inputAttributes: _propTypes2.default.object,
  inputLocation: _propTypes2.default.object,
  intl: _reactIntl.intlShape,
  label: _propTypes2.default.node,
  loadDetectedLocation: _propTypes2.default.func.isRequired,
  loadPlace: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  onLoad: _propTypes2.default.func,
  placeSuggestions: _propTypes2.default.array,
  queryPlaces: _propTypes2.default.func.isRequired,
  selectedItem: _propTypes2.default.object,
  setInputSelection: _propTypes2.default.func.isRequired,
  style: _propTypes2.default.oneOf(['underlined'])
};